import React from "react";
import styled, { css } from "styled-components";
import { DetailedCourse } from "@domain/lms/course/course";
import { CourseSection } from "@domain/lms/course/courseSection";
import { AttachmentSectionView } from "./attachmentSectionView";
import { DocumentSectionView } from "./documentSectionView";
import { ImageSectionView } from "./imageSectionView";
import { SubtitleSectionView } from "./subtitleSectionView";
import { TextSectionView } from "./textSectionView";
import { VideoSectionView } from "./videoSectionView";

interface SectionViewProps extends React.HTMLAttributes<HTMLDivElement> {
	section: CourseSection;
	course: DetailedCourse;
}
export const SectionView: React.FC<SectionViewProps> = ({ section, course, ...htmlProps }) => {
	return (
		<Container fullSize={section.type === "IMAGE" || section.type === "VIDEO"} {...htmlProps}>
			{section.type === "VIDEO" ? (
				<VideoSectionView section={section} course={course} />
			) : section.type === "TEXT" ? (
				<TextSectionView section={section} />
			) : section.type === "SUBTITLE" ? (
				<SubtitleSectionView section={section} />
			) : section.type === "ATTACHMENT" ? (
				<AttachmentSectionView section={section} course={course} />
			) : section.type === "PDF" ? (
				<DocumentSectionView section={section} course={course} />
			) : (
				<ImageSectionView section={section} course={course} />
			)}
		</Container>
	);
};

const Container = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "fullSize",
})<{ fullSize?: boolean }>`
	${({ fullSize }) =>
		fullSize &&
		css`
			margin-left: -50px;
			margin-right: -50px;

			@media (max-width: 900px) {
				margin-left: -16px;
				margin-right: -16px;
			}
		`}
`;
